import React from 'react';
import './Refund.css';

const Refund = () => {
  return (
    <div className="refund-page">
      {/* Hero Section */}
      <section className="refund-hero">
        <div className="container">
          <h1 className="refund-hero-title">Refund Policy</h1>
          <p className="refund-hero-subtitle">
            Last updated: January 2026
          </p>
        </div>
      </section>

      {/* Content Section */}
      <section className="refund-content">
        <div className="container">
          <div className="refund-document">
            <div className="refund-section">
              <h2>1. Subscription Refunds</h2>
              <p>
                Subscriptions to Tinder Plus, Tinder Gold, and Tinder Platinum are generally non-refundable. However, we may consider refund requests in certain circumstances.
              </p>
            </div>

            <div className="refund-section">
              <h2>2. 14-Day Cooling Off Period</h2>
              <p>
                If you are a resident of the European Union or the United Kingdom, you have the right to withdraw from your subscription within 14 days of purchase without giving any reason. To exercise this right, you must inform us of your decision.
              </p>
              <p>
                To request a refund during the cooling-off period, please contact our customer support team.
              </p>
            </div>

            <div className="refund-section">
              <h2>3. Refund Eligibility</h2>
              <p>You may be eligible for a refund if:</p>
              <ul>
                <li>You were charged for a subscription you did not authorize</li>
                <li>The service was not provided as described</li>
                <li>Technical issues prevented you from using the service</li>
                <li>Your account was terminated through no fault of your own</li>
              </ul>
            </div>

            <div className="refund-section">
              <h2>4. Non-Refundable Situations</h2>
              <p>Refunds are typically not provided in the following cases:</p>
              <ul>
                <li>You changed your mind about the purchase</li>
                <li>You found a better deal elsewhere</li>
                <li>You failed to cancel before the renewal date</li>
                <li>Your account was suspended for violating our Terms</li>
                <li>You have already used premium features extensively</li>
              </ul>
            </div>

            <div className="refund-section">
              <h2>5. How to Request a Refund</h2>
              <p>To request a refund:</p>
              <ul>
                <li><strong>iOS Users:</strong> Contact Apple Support or request a refund through your Apple ID account settings</li>
                <li><strong>Android Users:</strong> Contact Google Play Support or request a refund through the Google Play Store</li>
                <li><strong>Web Users:</strong> Contact our customer support team at support@tinder.com</li>
              </ul>
              <p>
                Please include your account email, transaction ID, and reason for the refund request.
              </p>
            </div>

            <div className="refund-section">
              <h2>6. Processing Time</h2>
              <p>
                Refund requests are typically processed within 5-10 business days. The time it takes for the refund to appear in your account depends on your payment method and financial institution.
              </p>
            </div>

            <div className="refund-section">
              <h2>7. Partial Refunds</h2>
              <p>
                In some cases, we may offer a partial refund based on the unused portion of your subscription. This is evaluated on a case-by-case basis.
              </p>
            </div>

            <div className="refund-section">
              <h2>8. Gifts and Promotional Items</h2>
              <p>
                Gift subscriptions and promotional items are non-refundable and cannot be exchanged for cash.
              </p>
            </div>

            <div className="refund-section">
              <h2>9. Chargebacks</h2>
              <p>
                If you initiate a chargeback with your bank or credit card company, your account may be suspended until the matter is resolved. We encourage you to contact us directly for refund requests.
              </p>
            </div>

            <div className="refund-section">
              <h2>10. Contact Us</h2>
              <p>
                If you have any questions about our Refund Policy, please contact us at:
              </p>
              <p>
                <strong>Email:</strong> support@tinder.com<br />
                <strong>Address:</strong> 8750 N. Central Expressway, Dallas, TX 75231
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Refund;
